export const ourMissionTextContent = {
  headingText: "Our Fast Casino Game Development Services",
  btnText: "Connect With Us",
  imageSrc: "/assets/stock-img/our_mission_img.webp",
  content: [
    {
      listContent_1: [
        { listText: "To be among top 10 sportsbook solutions providers" },
        { listText: "To acquire 100 tenants for iGaming book" },
        { listText: "To 3X revenue increase" },
        { listText: "Business office in Europe" },
        { listText: "To capture 50% market in North Africa & 20% in Latin America" },
        { listText: "To create a success story with each client" },
        { listText: "Grow business with our technological skills" },
      ],
    },
  ],
};
